<template>
    <div>
        <div v-if="loading" style=" height: 18.5rem; padding-top: 4rem;background: #fbfbfb;">
            <Spinner />
        </div>
        <div v-else class="match-mainMarket">
            <slot name="mainMarket" />
        </div>
        <div v-if="isShowExpandList" class="moreMarket">
            <div
                class="moreMarket-collapse"
                v-bind:class="{
                    JARVIS_MatchCard_Btn_MoreMarkets_List_Collapse: isAllMoreMarketExpanded,
                    JARVIS_MatchCard_Btn_MoreMarkets_List_Expand: !isAllMoreMarketExpanded,
                    'live-background': isLive,
                    'nonLive-background': !isLive,
                }"
                v-on:click="toggleCollapse"
            >
                <div
                    class="collapse-btn"
                    v-bind:class="{ 'live-background': isLive, 'nonLive-background': !isLive }"
                >
                    <div class="moreMarket-collapse-btn trapezoid" v-bind:class="{ 'live-btn': isLive, 'nonLive-btn': !isLive }">
                        <div class="moreMarket-collapse-text">
                            <span>{{ isAllMoreMarketExpanded ? i18n.t('moreMarket_collapseList') : i18n.t('moreMarket_expandList') }}</span>
                            <SvgIcon iconName="systemIcon_arrowBottom" v-bind:class="{ _rotate: isAllMoreMarketExpanded }" />
                        </div>
                    </div>
                </div>
                <div class="moreMarket-collapse-bottomBar" />
            </div>
            <slot name="moreMarket" v-bind:isCollapse="isAllMoreMarketExpanded" />
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, ref } from 'vue';
    import Spinner from '@/components/common/Spinner.vue';
    import { i18n } from '@/libraries/i18n';
    import SvgIcon from '@/svg/SvgIcon.vue';

    export default defineComponent({
        name: 'Markets',
        components: {
            Spinner,
            SvgIcon,
        },
        props: {
            isLive: {
                type: Boolean,
                default: false,
            },
            loading: {
                type: Boolean,
                default: false,
            },
            isShowExpandList: {
                type: Boolean,
                default: false,
            },
        },
        setup() {
            const isAllMoreMarketExpanded = ref(false);
            const toggleCollapse = () => {
                isAllMoreMarketExpanded.value = !isAllMoreMarketExpanded.value;
            };
            return {
                toggleCollapse,
                isAllMoreMarketExpanded,
                i18n,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @import "@/scss/components/match";
    @import "@/scss/components/odd";
</style>
